import { useSyncExternalStore } from "react";

import chatStorage from "~/helpers/aiChat/chatStorage";

const useHasChatHistory = (): boolean =>
	useSyncExternalStore(chatStorage.subscribeHistory, chatStorage.hasHistory, chatStorage.hasHistory);

export default useHasChatHistory;
